// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 4.7,
  H_DESKTOP: 4.7,
  H_DESKTOP_OFFSET: 80 - 16,
};

export const NAV = {
  W_VERTICAL: 15.6,
  W_MINI: 6.6,
};
